import { z } from 'zod';

export const getOrderReqDto = z.object({
  orderId: z.string(),
});
export type GetOrderReqDto = z.infer<typeof getOrderReqDto>;
